import { useEffect, useState } from 'react';
import { Input, Button, Checkbox, Message } from '@arco-design/web-react';
import { IconPhone, IconLock } from '@arco-design/web-react/icon';
import styles from './index.module.less';
import { useAuth } from '@/context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAppConfig, sendVerificationCode } from '@/app/user';
import NicoLogo from '@/assets/other/logo.png';
import { useBackground } from '@/context/BackgroundContext';

function LoginPage() {
  const [phone, setPhone] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [appConfig, setAppConfig] = useState<any>(null);

  const {updateBackground} = useBackground();

  const handleSendCode = async () => {
    if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
      Message.error('请输入正确的手机号');
      return;
    }

    setCountdown(60);
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // 发送验证码的API调用
    await sendVerificationCode(phone);
    Message.success('验证码已发送');
  };

  const handleLogin = async () => {
    if (!phone) {
      Message.error('请输入手机号');
      return;
    }
    if (!verificationCode) {
      Message.error('请输入验证码');
      return;
    }
    if (!agreed) {
      Message.error('请阅读并同意用户协议和隐私政策');
      return;
    }

    try {
      // 调用 AuthContext 中的登录方法
      await login(phone, verificationCode);
      // Message.success('登录成功');

      // 获取重定向路径，默认为首页
      const redirect = searchParams.get('redirect') || '/';
      navigate(redirect);
    } catch (error) {
      Message.error('登录失败，请重试');
    }
  };

  useEffect(() => {
    getAppConfig().then((res) => {
      setAppConfig(res);
    });
  }, []);

  return (
    <div className={styles.loginContainer}>
      <div className={styles.backButton}>
        <i className={styles.arrowLeft}></i>
      </div>

      <div className={styles.logoContainer}>
        <img src={appConfig?.logo} alt="NiCO house" className={styles.logo} />
      </div>

      <div className={styles.formContainer}>
        <div className={styles.inputWrapper}>
          <Input prefix={<IconPhone />} placeholder="请输入手机号" value={phone} onChange={setPhone} />
        </div>

        <div className={styles.verificationWrapper}>
          <Input prefix={<IconLock />} placeholder="请输入验证码" value={verificationCode} onChange={setVerificationCode} />
          <Button type="primary" onClick={handleSendCode} disabled={countdown > 0} className={styles.codeButton}>
            {countdown > 0 ? `${countdown}秒后重试` : '获取验证码'}
          </Button>
        </div>

        <Button type="primary" long onClick={handleLogin} className={styles.loginButton}>
          登录
        </Button>

        <div className={styles.agreementWrapper}>
          <Checkbox checked={agreed} onChange={setAgreed}>
            <span className={styles.agreementText}>
              我已阅读并同意
              <a href="#" className={styles.link}>
                《用户协议》
              </a>{' '}
              和
              <a href="#" className={styles.link}>
                《隐私政策》
              </a>
            </span>
          </Checkbox>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
